/** Une écriture réussie hors de l'écran rend ses listes en mémoire périmées. */
const EVENT = 'taki:external-record-mutation';

export interface ExternalRecordMutation {
  recordId?: string;
}

export function announceExternalRecordMutation(mutation: ExternalRecordMutation): void {
  window.dispatchEvent(new CustomEvent<ExternalRecordMutation>(EVENT, { detail: mutation }));
}

export function onExternalRecordMutation(listener: (mutation: ExternalRecordMutation) => void): () => void {
  const receive = (event: Event): void => listener((event as CustomEvent<ExternalRecordMutation>).detail);
  window.addEventListener(EVENT, receive);
  return () => window.removeEventListener(EVENT, receive);
}
